// Helpers used by both the browser bundle and the Node prerender: no DOM,
// no extensionless imports.

export const escapeHtml = (value) =>
  String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const DOMAIN = /^[a-z0-9-]+(\.[a-z0-9-]+)+$/i;

// Items without an explicit url link to their heading only when the heading
// is a domain ("giga-hamburg.de"); "AI insurance platform" gets no link.
export const getItemUrl = ({ url, heading }) => {
  if (url) return url;
  const name = String(heading || '').trim();
  return DOMAIN.test(name) ? `https://${name}` : null;
};
